import { basicEnum } from "./base";

export const ProvisionStatusEnum = basicEnum([
    {
        label: "Menunggu",
        value: "W", // Waiting
    },
    {
        label: "Diproses",
        value: "P", // Provisioning
    },
    {
        label: "Tersedia",
        value: "R", // Ready
    },
    {
        label: "Diterima",
        value: "D", // Done
    },
    {
        label: "Dibatalkan",
        value: "C", // Canceled
    },
]);

export namespace ProvisionStatusEnum {
    export type Labels = (typeof ProvisionStatusEnum)["labels"][number];
    export type Values = (typeof ProvisionStatusEnum)["values"][number];
}
